<template>
  <div class="projectIndex">
    <simpleSearch
      :logo="information.logo"
      :searchAttrs="information.searchAttrs"
    ></simpleSearch>
    <headTop></headTop>
    <globalCarousel
      :carouselList="carouselList"
      style="padding-left: 10px; padding-right: 10px"
    ></globalCarousel>
    <el-row :gutter="20" style="margin-top: 25px">
      <el-col :sapn="24">
        <div class="titleTop">
          <h5 style="margin: 0">Data statistics</h5>
        </div>
      </el-col>
      <el-col :span="24" style="padding-left: 20px; padding-right: 20px">
        <sankit></sankit>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-top: 20px; margin-bottom: 100px">
      <el-col :sapn="24">
        <div class="titleTop">
          <h5 style="margin: 0">Data resources</h5>
        </div>
      </el-col>
      <el-col :span="24">
        <globalReferences
          :literatureList="information.literatureList"
        ></globalReferences>
      </el-col>
    </el-row>
    <backToTop></backToTop>
    <bottomFooter :bottom="information.bottom"></bottomFooter>
  </div>
</template>
<script>
import { baseConfig, pathConfig } from '../assets/util/baseConfig'

import simpleSearch from '@/components/simpleSearch'
import head from '@/components/head'
import globalReferences from '@/components/globalReferences'
import globalCarousel from '@/components/globalCarousel'
import indexIntroduction from '@/components/indexIntroduction'
import bottomPic from '@/components/bottomPic'
import bottomNews from '@/components/bottomNews'
import bottomLiteratures from '@/components/bottomLiteratures'
import pie from '@/components/pie'
import sankit from '@/components/sankit'
import bottomMap from '@/components/bottomMap'
import bottomLink from '@/components/bottomLink'
import backToTop from '@/components/backToTop'
import bottomFooter from '@/components/bottomFooter'

export default {
  data() {
    return {
      baseConfig: baseConfig,
      pathConfig: pathConfig,
      apiParams: 'index_information/',
      information: {},
      chartsData: [],
      searchParams: [],
      backgroundImage: '',
      newsHeight: 0,
      carouselList: []
    }
  },
  components: {
    simpleSearch: simpleSearch,
    headTop: head,
    globalReferences: globalReferences,
    globalCarousel: globalCarousel,
    indexIntroduction: indexIntroduction,
    bottomPic: bottomPic,
    bottomNews: bottomNews,
    bottomLiteratures: bottomLiteratures,
    pie: pie,
    sankit: sankit,
    bottomMap: bottomMap,
    bottomLink: bottomLink,
    backToTop: backToTop,
    bottomFooter: bottomFooter
  },
  mounted() {
    this.initPage()
    this.initPie()

    document.title = this.baseConfig.project
  },
  methods: {
    initPage() {
      let _this = this

      let requestParams = {}

      requestParams.project = this.baseConfig.project

      const successCallBack = (res) => {
        if (res && res.code === 1) {
          _this.information = res.data

          let logoParam = {
            projectName: res.data.projectName,
            imgUrl: res.data.logo.imgUrl,
            shape: res.data.logo.shape
          }

          _this.$set(_this.information, 'logo', logoParam)

          _this.information.searchAttrs = {}

          _this.information.searchAttrs.speciesList = res.data.speciesList
          _this.information.searchAttrs.homeText = res.data.homeText
          _this.backgroundImage = res.data.backgroundImage.imgUrl
          _this.carouselList = res.data.homePictureList

          let bannerUrl = ''

          if (res.data.function_background_image) {
            bannerUrl = res.data.function_background_image.imgUrl
          } else {
            bannerUrl = res.data.backgroundImage.imgUrl
          }

          window.localStorage.setItem(
            this.baseConfig.project + 'bannerUrl',
            bannerUrl
          )
        } else {
          _this.showAlert('error', res.msg)
        }
      }
      const errCallBack = (res) => {
        if (res && res.status === 200) {
        } else if (res) {
          _this.showAlert('error', res.msg)
        }
      }

      this.$post(
        this.pathConfig.apiPath + this.pathConfig.toolsPath + this.apiParams,
        requestParams,
        successCallBack,
        errCallBack
      )
    },
    initPie(data) {
      let _this = this

      let requestParams = {
        project: this.baseConfig.project,
        chartColumns: this.baseConfig.chartsPieColumns,
        params: data || []
      }

      const successCallBack = (res) => {
        if (res && res.code === 1) {
          _this.chartsData = res.data.charts
        } else {
          _this.showAlert('error', res.msg)
        }
      }

      const errCallBack = (res) => {
        if (res && res.status === 200) {
        } else if (res) {
          _this.showAlert('error', res.msg)
        } else {
        }
      }

      this.$post(
        this.pathConfig.apiPath +
          this.pathConfig.toolsPath +
          'information_pie/',
        requestParams,
        successCallBack,
        errCallBack
      )
    },
    setSearchContent(data) {
      this.initPie(data)
    },
    setNewsHeight(data) {
      this.newsHeight = data
    }
  }
}
</script>
<style scoped>
.el-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
body {
  min-width: 1170px;
  margin: 0 !important;
  padding: 0 !important;
}

a {
  cursor: pointer;
  text-decoration: none !important;
  color: #193c5a !important;
}

.projectIndex >>> h5 {
  font-size: 20px;
  text-align: center;
}
.projectIndex >>> .titleTop {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue